import React from "react";
import "./BarcodeYBI.css";
import { useBarcodeYBI } from "./useBarcodeYBI";
import { constantNoMesin } from "../../util/constant";
import PopUpComponent from "../../components/PopUp/PopUpComponent";
import Select from "react-select";
import moment from "moment";

const BarcodeYBI = () => {
  const {
    dataUser,
    tglProduksi,
    setTanggalProduksi,
    jumlahBarang,
    setJumlahBarang,
    shift,
    setShift,
    noMesin,
    setNoMesin,
    operator,
    setOperator,
    dataSelect,
    produkPick,
    setProdukPick,
    popUpErrorSubmit,
    setPopUpErrorSubmit,
    popUpSubmit,
    setPopUpSubmit,
    handleKirimBarcode,
    subMenu,
    setSubMenu,
    filterDate,
    setFilterDate,
    handleExportBarcode,
    bagian,
    setBagian,
    dataTemp,
    jumlahBarcode,
    setJumlahBarcode,
    bagianInputBarcode,
    setBagianInputBarcode,
  } = useBarcodeYBI();

  const formatDot = (value) => {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  return (
    <div className="container_dashboard byb-page">
      {popUpSubmit ? (
        <PopUpComponent>
          <p>Terima Kasih! Anda Telah Men-update Stock Masuk Bahan.</p>
          <div className="byb-popup-actions">
            <button
              className="byb-popup-btn"
              onClick={() => setPopUpSubmit(false)}
            >
              OK
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      {popUpErrorSubmit ? (
        <PopUpComponent>
          <p className="byb-error">
            Mohon pastikan semua kolom yang Berbintang Merah Terisi !
          </p>
          <div className="byb-popup-actions">
            <button
              className="byb-popup-btn"
              onClick={() => setPopUpErrorSubmit(false)}
            >
              OK
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      <p className="byb-title">BARCODE PT. YBI</p>
      <div className="byb-tabs">
        <p
          className={subMenu === "Input" ? "byb-tab byb-tab-active" : "byb-tab"}
          onClick={() => setSubMenu("Input")}
        >
          Input
        </p>
        <p
          className={
            subMenu === "Riwayat" ? "byb-tab byb-tab-active" : "byb-tab"
          }
          onClick={() => setSubMenu("Riwayat")}
        >
          Riwayat
        </p>
      </div>
      {subMenu === "Input" ? (
        <div className="byb-form">
          <div className="byb-field">
            <p className="byb-label">
              Tgl Produksi<label className="byb-req">*</label>
            </p>
            <input
              type="date"
              className="byb-date"
              value={tglProduksi}
              onChange={(e) => setTanggalProduksi(e.target.value)}
            />
          </div>
          {dataUser.tim === 2 ? (
            <div className="byb-radio-group">
              <div
                className="byb-radio"
                onClick={() => setBagianInputBarcode("1")}
              >
                <input
                  type="radio"
                  value="Printing"
                  checked={bagianInputBarcode === "Printing"}
                />
                <label>Printing</label>
              </div>
              <div
                className="byb-radio"
                onClick={() => setBagianInputBarcode("Finishing")}
              >
                <input
                  type="radio"
                  value="Finishing"
                  checked={bagianInputBarcode === "1"}
                />
                <label>Finishing</label>
              </div>
            </div>
          ) : (
            ""
          )}
          <div className="byb-field">
            <p className="byb-label">
              Mesin<label className="byb-req">*</label>
            </p>
            <select
              onChange={(e) => setNoMesin(e.target.value)}
              className="byb-select"
              defaultValue="Pilih Mesin"
            >
              <option selected={noMesin === "Pilih Mesin"} disabled>
                Pilih Mesin
              </option>
              {constantNoMesin &&
                constantNoMesin.map((data, i) => (
                  <option value={data} key={i} selected={noMesin === data}>
                    {data}
                  </option>
                ))}
            </select>
          </div>
          <div className="byb-field">
            <p className="byb-label">
              Nama Barang<label className="byb-req">*</label>
            </p>
            <div className="byb-select-product">
              <Select
                options={dataSelect}
                value={produkPick || ""}
                onChange={setProdukPick}
              />
            </div>
          </div>
          <div className="byb-radio-group">
            <div className="byb-radio" onClick={() => setShift("1")}>
              <input type="radio" value="1" checked={shift === "1"} />
              <label>SHIFT 1</label>
            </div>
            <div className="byb-radio" onClick={() => setShift("2")}>
              <input type="radio" value="2" checked={shift === "2"} />
              <label>SHIFT 2</label>
            </div>
            <div className="byb-radio" onClick={() => setShift("3")}>
              <input type="radio" value="3" checked={shift === "3"} />
              <label>SHIFT 3</label>
            </div>
          </div>

          <div className="byb-field">
            <p className="byb-label">
              Operator<label className="byb-req">*</label>
            </p>
            <input
              type="text"
              className="byb-input"
              placeholder="Masukkan Nama Operator"
              value={operator}
              onChange={(e) => setOperator(e.target.value)}
              onWheel={(e) => e.target.blur()}
            />
          </div>
          <div className="byb-field">
            <p className="byb-label">
              Isi per-Kemasan<label className="byb-req">*</label>
            </p>
            <input
              type="number"
              className="byb-input"
              placeholder="Isi Per-Kemasan (Pcs)"
              value={jumlahBarang}
              onChange={(e) => setJumlahBarang(e.target.value)}
              onWheel={(e) => e.target.blur()}
            />
          </div>
          <div className="byb-field">
            <p className="byb-label">Jumlah Barcode (Pcs)</p>
            <input
              type="number"
              className="byb-input"
              placeholder="Masukkan Jumlah (Pcs)"
              value={jumlahBarcode}
              onChange={(e) => setJumlahBarcode(e.target.value)}
              onWheel={(e) => e.target.blur()}
            />
          </div>
          <div className="byb-submit-wrap">
            <div className="byb-submit" onClick={() => handleKirimBarcode()}>
              Kirim
            </div>
          </div>
        </div>
      ) : (
        <div className="byb-history">
          <div className="byb-filter">
            <div className="byb-field">
              <p>Pilih Tanggal</p>
              <input
                type="date"
                className="byb-date"
                value={filterDate}
                onChange={(e) => setFilterDate(e.target.value)}
              />
            </div>
            <div className="byb-field">
              <p>Pilih Bagian</p>
              <select
                defaultValue="Pilih Bagian"
                onChange={(e) => setBagian(e.target.value)}
                className="byb-select"
                value={bagian}
              >
                <option selected disabled>
                  Pilih Bagian
                </option>
                <option value="Finishing">Finishing</option>
                <option value="Printing">Printing</option>
              </select>
            </div>
            <p
              className="byb-btn-reset"
              onClick={() => setBagian("Pilih Bagian")}
            >
              Reset
            </p>
            <button
              className="byb-btn-export"
              onClick={() => handleExportBarcode()}
            >
              Export Barcode
            </button>
          </div>
          <div className="byb-table-wrap">
            <table className="byb-table">
              <tr>
                <th className="byb-th">No</th>
                <th className="byb-th">Tgl Produksi</th>
                <th className="byb-th">Part Number</th>
                <th className="byb-th">Produk</th>
                <th className="byb-th">Jumlah</th>
                <th className="byb-th">Operator</th>
                <th className="byb-th">Bagian</th>
                <th className="byb-th">Update By</th>
              </tr>
              {dataTemp &&
                dataTemp.map((e, index) => {
                  return (
                    <tr>
                      <td className="byb-td">{index + 1}</td>
                      <td className="byb-td">
                        {moment(e && e.tglProduksi)
                          .utcOffset("+0700")
                          .format("DD-MM-YYYY")}
                      </td>
                      <td className="byb-td">{e && e.partNumber}</td>
                      <td className="byb-td">{e && e.produk}</td>
                      <td className="byb-td byb-td-number">
                        {formatDot(e && e.jumlah)}
                      </td>
                      <td className="byb-td">{e && e.operator}</td>
                      <td className="byb-td">{e && e.bagian}</td>
                      <td className="byb-td">
                        {e && e.updatedBy.split(" ").slice(0, 1).join(" ")}
                      </td>
                    </tr>
                  );
                })}
            </table>
          </div>
        </div>
      )}
    </div>
  );
};
export default BarcodeYBI;
